var map = {
	"./app-default-icon.svg": "83Ci",
	"./apply-opening-shop.svg": "QnjV",
	"./apps-management.svg": "5ID6",
	"./author-details.svg": "LbiK",
	"./cloud-information.svg": "6ae4",
	"./clue-manage.svg": "LzCB",
	"./complete.svg": "PGk/",
	"./customer-management.svg": "POiw",
	"./del-management.svg": "EZMJ",
	"./delivery-management.svg": "kbJs",
	"./downLoad.svg": "h5dG",
	"./enterprise-application.svg": "7sZh",
	"./enterprise-integration.svg": "V74M",
	"./enterprise-management.svg": "dpjP",
	"./enterprise-shop.svg": "ju8k",
	"./environment.svg": "uyUx",
	"./example.svg": "OOLB",
	"./eye.svg": "4wdf",
	"./form.svg": "sTIr",
	"./history-details.svg": "OhBk",
	"./home.svg": "U9Ws",
	"./infrastructure.svg": "LVRl",
	"./install-details.svg": "DuY6",
	"./introduce-details.svg": "DdXB",
	"./lastr-round.svg": "rGym",
	"./login-mall.svg": "xzZT",
	"./marker.svg": "0+/s",
	"./myApp-details.svg": "xCj3",
	"./myApp-early.svg": "zo+7",
	"./myApp-icon.svg": "xKa8",
	"./myApp-mgt.svg": "Crti",
	"./myApp-order.svg": "9xwj",
	"./myApp-shelf.svg": "6vFU",
	"./noData.svg": "ew2i",
	"./nopermissions.svg": "0baE",
	"./ok.svg": "zWFk",
	"./order-return-reason.svg": "PeRC",
	"./order-return.svg": "vigK",
	"./order-setting.svg": "LpN3",
	"./order.svg": "gYtG",
	"./organization.svg": "Jost",
	"./overview.svg": "UPzn",
	"./password.svg": "QjmH",
	"./product-add.svg": "Cuqr",
	"./product-attr.svg": "Aain",
	"./product-brand.svg": "JTBo",
	"./product-cate.svg": "G6Qz",
	"./product-comment.svg": "b5pz",
	"./product-list.svg": "qzoa",
	"./product-recycle.svg": "WSWy",
	"./product.svg": "UHi4",
	"./role-management.svg": "KQ1L",
	"./round.svg": "Pgc4",
	"./search.svg": "Bx0U",
	"./share.svg": "BDVe",
	"./shop-info.svg": "D8Qh",
	"./shop-management.svg": "Daxy",
	"./sms-ad.svg": "2epx",
	"./sms-coupon.svg": "0Kk2",
	"./sms-flash.svg": "/KjT",
	"./sms-hot.svg": "If2y",
	"./sms-new.svg": "vvoC",
	"./sms-subject.svg": "4H1Q",
	"./sms.svg": "AS+9",
	"./store-settings.svg": "caz2",
	"./table.svg": "oSYw",
	"./tags-management.svg": "4EXG",
	"./template.svg": "//Qc",
	"./tenant-management.svg": "waHO",
	"./total-today.svg": "le/7",
	"./total-week.svg": "csmh",
	"./total-yesterday.svg": "C15R",
	"./tree.svg": "3eCm",
	"./unfinished.svg": "ZbuY",
	"./use-details.svg": "VyWU",
	"./user-management.svg": "noTf",
	"./user-set.svg": "qZX+",
	"./user.svg": "VdD3",
	"./warning.svg": "TcIt"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "90Fk";


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg nonrecursive \.svg$
// module id = 90Fk
// module chunks = 0